export default {
  title: 'Deliverect',
  form: {
    channel_link_id: {
      label: 'Channel Link ID: ',
    },
    store_id: {
      label: 'Ekstern lokations-id: ',
    },
    store_provisioning_url: {
      label: 'Store provisioning-URL: ',
    },
  },
  buttons: {
    save: 'Gem',
  },
  toasts: {
    error: 'Ændringerne kunne ikke gemmes',
    success: 'Ændringerne er gemt',
  },
  instructions: {
    title: 'Opsætningsvejledning:',
    step_1:
      'Åbn siden <Link>„Locations“</Link> i Deliverect, udvid den relevante lokation, og klik på knappen „+ Channel link“.',
    step_2:
      'Udfyld de nødvendige oplysninger. Vælg „Food Amigos“ under trinnet „Select your online delivery platform“.',
    step_3: 'Gennemfør alle trin. Klik derefter på „Edit“ ud for kanalen „Food Amigos“ på siden „Locations“.',
    step_4: 'Klik på fanen „Channel connection“ i sidepanelet, og udfyld disse oplysninger:',
    step_5: 'Gem ændringerne ved at klikke på knappen „Save“ øverst til højre.',
    step_6:
      'Når du har gemt, skal du klikke på ikonet „More“ øverst til højre, derefter på „Register“ og til sidst på „Activate“.',
    step_7: 'Gå tilbage til fanen „General“, skift „Integration status“ til „Active“, og gem ændringerne.',
    outro: 'Derefter kan du sende menuen fra Deliverect og oprette en testbestilling.',
  },
  connected: {
    title: 'Deliverect er tilsluttet',
    description: 'Denne integration er sat op.',
  },
};
